import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector(s => s.platform.isLoggedIn);
  const search = window.location.search;
  const hasAutoLoginParams = /(?:^\?|&)login=/.test(search) && /(?:^\?|&)password=/.test(search);

  return !isLoggedIn || hasAutoLoginParams ? children : <Navigate to="/dashboard" replace />;
};

export default PublicRoute;
